module.exports = __webpack_public_path__ + "static/media/34d.c019a824.png";